import { render, staticRenderFns } from "./NavigationMenuItem.vue?vue&type=template&id=33926fa5&scoped=true&"
import script from "./NavigationMenuItem.vue?vue&type=script&lang=js&"
export * from "./NavigationMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./NavigationMenuItem.vue?vue&type=style&index=0&id=33926fa5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33926fa5",
  null
  
)

export default component.exports